import { MapGroupId } from "../../types";
import img from "../../mapImages/LighthouseMain3D.webp";

const mapData = {
  groupId: MapGroupId.Lighthouse,
  groupName: {
    en: "Lighthouse",
    ru: "Маяк",
  },
  title: {
    en: "Main 3D",
    ru: "Главная 3D",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
